import taskimage from "../assets/home/sidebar/tasks1.png"
import time from "../assets/home/sidebar/time.png"
export const taskTodoData = [
    {
        id: "1",
        icon: taskimage,
        title: "Tasks to do",
        count: "3",
        color: '#2554BC',
    },
    {
        id: "1",
        icon: time,
        title: "Time off requests",
        count: "1",
        color: "#C71D04"
    }
];